import { FormattedMessage } from 'react-intl';
import { useSelector } from '@tmapy/redux';
import { QUERY_STATE } from '@tmapy/beetlejuice-utils';

import { Table } from '@tmapy/style-guide';

import { DocListItemDefault } from './DocListItemDefault';
import { docFormMessages, docListMessages } from './docsMessages';
import { ResponsiblePersonHeader } from './ResponsiblePersonColumn';
import { DOC_ROUTER_FILTER_DMVS_DTI, usableFilterItemsForAppType } from '../constants';

import type { DocListResponse } from '../../openapi/types';
import { LoadNextItemsBar } from '../../app/components/LoadNextItemsBar';

export type DocListDefaultProps = {
  docList: DocListResponse[];
  queryState: QUERY_STATE;
  docCount: number | undefined;
  handleNextDocsBtnClick: () => void;
};
export const DocListDefault: React.FC<DocListDefaultProps> = ({
  docList,
  queryState,
  docCount,
  handleNextDocsBtnClick,
}) => {
  const menuRouteFilterId = useSelector((state) => state.menu.menuRouteFilterId);
  const customerType = useSelector((state) => state.app.config.customerType);
  const usableItems = usableFilterItemsForAppType[customerType];
  const isDti = DOC_ROUTER_FILTER_DMVS_DTI.includes(menuRouteFilterId);

  return (
    <div className='sg-u-box sg-a-px-2 sg-a-pb-2 sg-u-vs-2'>
      <div className='sg-a-mx--2'>
        <Table isClickable>
          <thead>
            <tr>
              <th className='sg-a-ta-c'>
                <FormattedMessage {...docListMessages.docListColumnState} />
                <br />
                <FormattedMessage {...docListMessages.docListColumnNumber} />
              </th>
              {usableItems.includes('documentation_type') && (
                <th className='sg-a-ta-c'>
                  <FormattedMessage {...docListMessages.docListColumnDocType} />
                </th>
              )}
              <th>
                <FormattedMessage {...docListMessages.docListColumnName} />
                <br />
                <FormattedMessage {...docListMessages.docListColumnDescription} />
              </th>
              {usableItems.includes('cadasters') && (
                <th>
                  <FormattedMessage {...docListMessages.docListColumnCadaster} />
                </th>
              )}
              {usableItems.includes('owner') && (
                <th>
                  <FormattedMessage {...docListMessages.docListColumnOwner} />
                </th>
              )}
              {usableItems.includes('prejimka_type') && (
                <th>
                  <FormattedMessage {...docListMessages.docListColumnPrejimkaType} />
                </th>
              )}
              <th className='sg-a-ta-r'>
                <FormattedMessage
                  {...docListMessages[
                    menuRouteFilterId === 'managerDocListIsDtm' ||
                    menuRouteFilterId === 'managerDocListPodaniKad'
                      ? 'docListColumnDtmkCreated'
                      : 'docListColumnCreated'
                  ]}
                />
                {customerType === 'gp' && (
                  <>
                    <br />
                    <span className='sg-u-c-cta-black'>
                      <FormattedMessage {...docListMessages.docListColumnAccepted} />
                    </span>
                  </>
                )}
                {usableItems.includes('history') && (
                  <>
                    <br />
                    <span className='dmx-u-c-cta-red'>
                      <FormattedMessage
                        {...docListMessages[
                          customerType === 'gp' ? 'docListColumnGpClosed' : 'docListColumnClosed'
                        ]}
                      />
                    </span>
                  </>
                )}
                {customerType === 'gp' && (
                  <>
                    <br />
                    <span className='dmx-u-c-cta-blue'>
                      <FormattedMessage {...docFormMessages.closed} />
                    </span>
                  </>
                )}
              </th>
              {usableItems.includes('dmvs_id_podani') && (
                <th>
                  <FormattedMessage {...docListMessages.docListColumnDmvsIdPodani} />
                </th>
              )}
              {usableItems.includes('dmvs_source') && (
                <th>
                  <FormattedMessage {...docListMessages.docListColumnDmvsSource} />
                </th>
              )}
              {usableItems.includes('creatorFullName') && (
                <th>
                  <FormattedMessage
                    {...docListMessages[isDti ? 'docListColumnSubjekt' : 'docListColumnAuthor']}
                  />
                </th>
              )}
              {usableItems.includes('receiverFullName') && (
                <th>
                  <FormattedMessage {...docListMessages.docListColumnReceiver} />
                </th>
              )}
              {usableItems.includes('editorManagerFullName') && (
                <th>
                  <FormattedMessage {...docListMessages.docListColumnEditorManager} />
                </th>
              )}
              <ResponsiblePersonHeader />
              <th />
              <th />
            </tr>
          </thead>
          <tbody>
            {docList.map((docItem) => (
              <DocListItemDefault key={docItem.id} {...docItem} />
            ))}
          </tbody>
        </Table>
      </div>
      <LoadNextItemsBar
        count={docList.length}
        total={docCount!}
        queryState={queryState}
        onNextBtnClick={handleNextDocsBtnClick}
      />
    </div>
  );
};
